import {useIntl} from 'react-intl';
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Heading,
  Table,
  Thead,
  Th,
  Tr,
  Td,
  Tbody,
  TableProps,
} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {fantasyRules, predictionsRules} from './';

interface ScoringSectionProps {
  section: typeof fantasyRules.scoringSystem | typeof predictionsRules.scoringSystem;
}

export function ScoringSection({section}: ScoringSectionProps) {
  const t = useTranslate();

  return (
    <AccordionItem borderTop="0" borderBottom={{md: 0}} ps={[0, null, 4]}>
      <AccordionButton
        justifyContent="space-between"
        _expanded={{pb: 2}}
        ps="0"
        pb="7"
        transition="padding 0.5s"
        _focus={{}}
      >
        <Heading fontSize={['md', null, 'xl']} textAlign="start">
          {t(section.heading)}
        </Heading>

        <AccordionIcon boxSize="8" />
      </AccordionButton>

      <AccordionPanel ps="0">
        <ScoringSectionRules rulesGroup={section.scoring.positive} isPositive roundedTop="sm" />

        {section.scoring.negative && (
          <ScoringSectionRules rulesGroup={section.scoring.negative} isPositive={false} roundedBottom="sm" />
        )}
      </AccordionPanel>
    </AccordionItem>
  );
}

interface ScoringSectionRulesProps extends TableProps {
  isPositive: boolean;
  rulesGroup:
    | typeof fantasyRules.scoringSystem.scoring.positive
    | typeof fantasyRules.scoringSystem.scoring.negative
    | typeof predictionsRules.scoringSystem.scoring.positive;
}

const ScoringSectionRules = ({rulesGroup, isPositive, ...props}: ScoringSectionRulesProps) => {
  const format = useIntl().formatNumber;

  const t = useTranslate();

  return (
    <Table fontSize="sm" overflow="hidden" borderWidth="1px" borderColor="transparent" {...props}>
      <Thead>
        <Tr bgColor="black">
          <Th colSpan={2} color={isPositive ? 'green.400' : 'red.600'}>
            {t(rulesGroup.heading)}
          </Th>
        </Tr>
      </Thead>

      <Tbody borderWidth="1px">
        {rulesGroup.rules.map(({rule, points}) => (
          <Tr key={rule} borderColor="gray.400">
            <Td borderColor="gray.400" py="1.5" pe="4" lineHeight="1.7">
              {t(rule)}
            </Td>

            <Td borderColor="gray.400" ps="0" textAlign="end">
              {isPositive ? '+' : ''}
              {format(points)}
              {t('app.points')}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
